import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { InlineSVGModule } from 'ng-inline-svg-2';
import { AlertService } from '../../../core/services/alert.service';
import { ContactUsTopicList } from '../../../modules/landing-area/contact-us/enum';
import { ContactUsService } from '../../../modules/landing-area/contact-us/services/contact-us.service';
import { RecaptchaComponent } from '../../modules/inputs/components/recaptcha/recaptcha.component';
import { InputSelectComponent } from '../../modules/inputs/components/select/select.component';
import { InputTextComponent } from '../../modules/inputs/components/text/text.component';
import { InputTextareaComponent } from '../../modules/inputs/components/textarea/textarea.component';
import { buildForm } from './form';
import { SharedModule } from '../../shared-module';
@Component({
  selector: 'app-contact-us-section',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
  imports: [
    InputTextareaComponent,
    InputTextComponent,
    SharedModule,
    ReactiveFormsModule,
    InputSelectComponent,
    RecaptchaComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsSectionComponent {
  isShowErrors = signal<boolean>(false);
  form = buildForm();
  contactUsTopicList = ContactUsTopicList;

  constructor(
    private alertService: AlertService,
    private contactUsService: ContactUsService,
  ) {}
  async submit() {
    if (this.form.invalid) {
      this.isShowErrors.set(true);
      return;
    }
    this.isShowErrors.set(false);

    const res = await this.contactUsService.sendMessage(this.form.value);
    this.alertService.suucess(res.message);
    this.form.reset();
  }
}
